import { optinStatusType } from '../../pages/DroitImagePages/types';
import { firstInscriptionYearType, yearType } from '../../pages/FicheInscriptionPages/constants';
import { paymentModeType } from '../../pages/FicheInscriptionPages/types';
import {
    fundingKindType,
    masterSlugType,
    TRAINING_WITH_OPTIONS_SLUGS,
    TRAINING_WITHOUT_OPTIONS_SLUGS,
    trainingOptionType,
} from '../../pages/types';
import { performApiCall } from './utils';

const api = {
    getFormationInitiale,
    getFormationInitialeEntries,
    getFicheRenseignementEntries,
    getFicheRenseignementEntry,
    getFormationContinueEntries,
    getFormationContinue,
    getFicheInscriptionEntry,
    createFormationContinueEntry,
    createFormationInitialeEntry,
    createFicheRenseignementEntry,
    createFicheInscriptionEntry,
    getFicheInscriptionEntries,
    createDroitImageEntry,
    getDroitImageEntry,
    getDroitImageEntries,
    ping,
};

type formationContinueDtoType = {};
type formationInitialeDtoType = {
    selectedPromo: string;
    firstName: string;
    lastName: string;
    birthdate: string;
    placeOfBirth: string;
    nationality: string;
    email: string;
    phoneNumber: string;
    address: string;
    zipCode: string;
    town: string;
    gender: string;
    lastDiploma: string;
    lastEstablishment: string;
    otherDiploma: string;
    reference: string;
    previousProfession: string | null;
    parent1FirstName: string;
    parent1LastName: string;
    parent1Address: string;
    parent1Email: string;
    parent1ZipCode: string;
    parent1Town: string;
    parent1PhoneNumber: string;
    parent2FirstName: string;
    parent2LastName: string;
    parent2Address: string;
    parent2ZipCode: string;
    parent2Town: string;
    parent2Email: string;
    parent2PhoneNumber: string;
    motivation: string;
};
type ficheRenseignementDtoType = {
    selectedPromo: string;
    firstName: string;
    lastName: string;
    birthdate: string;
    placeOfBirth: string;
    nationality: string;
    email: string;
    phoneNumber: string;
    address: string;
    zipCode: string;
    town: string;
    parent1FirstName: string;
    parent1LastName: string;
    parent1Address: string;
    parent1Email: string;
    parent1ZipCode: string;
    parent1Town: string;
    parent1PhoneNumber: string;
    parent2FirstName: string;
    parent2LastName: string;
    parent2Address: string;
    parent2ZipCode: string;
    parent2Town: string;
    parent2Email: string;
    parent2PhoneNumber: string;
    idDocument: string;
    idNumber: string;
    idExpirationDate: string;
    visaNumber: string;
};

type ficheRenseignementEntryType = {
    id: string;
    createdAt: string;
    selectedPromo: string;
    firstName: string;
    lastName: string;
    birthdate: string;
    placeOfBirth: string;
    email: string;
    phoneNumber: string;
    address: string;
    parent1Name: string;
    parent1Address: string;
    parent1Contact: string;
    parent2Name: string;
    parent2Address: string;
    parent2Contact: string;
    idDocument: string;
    idNumber: string;
    idExpirationDate: string;
    visaNumber: string;
};

async function ping() {
    return performApiCall<{ ok: boolean }>('', 'GET');
}

async function createFormationContinueEntry(params: formationContinueDtoType) {
    return performApiCall<{ ok: boolean }>('formation-continue', 'POST', {
        kind: 'data',
        data: params,
    });
}

async function createFormationInitialeEntry(params: formationInitialeDtoType) {
    return performApiCall<{ ok: boolean }>('formation-initiale', 'POST', {
        kind: 'data',
        data: params,
    });
}

async function createFicheRenseignementEntry(params: ficheRenseignementDtoType) {
    return performApiCall<{ id: string }>('fiches-renseignements', 'POST', {
        kind: 'data',
        data: params,
    });
}

type formationInitialeEntryType = {
    id: string;
    createdAt: string;
    firstName: string;
    lastName: string;
    birthdate: string;
    nationality: string;
    email: string;
    phoneNumber: string;
    address: string;
    selectedPromo: string;
    gender: string;
    reference: string;
    parent1Name: string;
    parent1Address: string;
    parent1Contact: string;
    parent2Name: string;
    parent2Address: string;
    parent2Contact: string;
    motivation: string;
    lastDiploma: string;
    otherDiploma: string;
    previousProfession: string | null;
};

async function getFormationInitiale(id: string) {
    return performApiCall<formationInitialeEntryType>(
        `formation-entries/formation-initiale/${id}`,
        'GET',
    );
}
async function getFormationInitialeEntries() {
    return performApiCall<formationInitialeEntryType[]>(
        `formation-entries/formation-initiale`,
        'GET',
    );
}

async function getFicheRenseignementEntries() {
    return performApiCall<ficheRenseignementEntryType[]>(`fiches-renseignements`, 'GET');
}

async function getFicheRenseignementEntry(id: string) {
    return performApiCall<ficheRenseignementEntryType>(`fiches-renseignements/${id}`, 'GET');
}

async function getFormationContinue(id: string) {
    return performApiCall<formationContinueEntryType>(
        `formation-entries/formation-continue/${id}`,
        'GET',
    );
}

async function getFicheInscriptionEntry(id: string) {
    return performApiCall<ficheInscriptionEntryType>(`fiche-inscriptions/${id}`, 'GET');
}

async function getDroitImageEntry(id: string) {
    return performApiCall<droitImageEntryType>(`droit-image-forms/${id}`, 'GET');
}

async function getDroitImageEntries() {
    return performApiCall<droitImageEntryType[]>(`droit-image-forms`, 'GET');
}

async function getFicheInscriptionEntries() {
    return performApiCall<ficheInscriptionEntryType[]>(`fiche-inscriptions`, 'GET');
}

async function getFormationContinueEntries() {
    return performApiCall<formationContinueEntryType[]>(
        `formation-entries/formation-continue`,
        'GET',
    );
}

async function createFicheInscriptionEntry(formData: FormData) {
    return performApiCall<{ id: string }>(`fiche-inscriptions`, 'POST', {
        kind: 'form',
        data: formData,
    });
}

async function createDroitImageEntry(formData: FormData) {
    return performApiCall<{ id: string }>(`droit-image-forms`, 'POST', {
        kind: 'form',
        data: formData,
    });
}

const TRAININGS_KEYS = [...TRAINING_WITH_OPTIONS_SLUGS, ...TRAINING_WITHOUT_OPTIONS_SLUGS];
type trainingKeyType = (typeof TRAININGS_KEYS)[number];
type formationContinueEntryType = {
    id: string;
    createdAt: string;
    firstName: string;
    lastName: string;
    birthdate: string;
    placeOfBirth: string;
    nationality: string;
    email: string;
    phoneNumber: string;
    address: string;
    zipCode: string;
    town: string;
    diplomas: string[];
    jobs: string[];
    selectedTrainings: Record<
        trainingKeyType,
        { trainingOption: trainingOptionType; date: string } | undefined
    >;
    selectedMaster: masterSlugType | null;
    fundingKind: fundingKindType;
    fundingCompany: string | null;
    fundingSiret: string | null;
    fundingAddress: string | null;
    fundingManagementName: string | null;
    fundingManagementEmail: string | null;
};

type ficheInscriptionEntryType = {
    id: string;
    created_at: string;
    firstName: string;
    lastName: string;
    email: string;
    ineNumber: string;
    rfFirstName: string;
    rfLastName: string;
    rfAddress: string;
    rfZipCode: string;
    rfCity: string;
    rfMobilePhoneNumber: string;
    rfEmail: string;
    rfJob: string;
    rfJobPhoneNumber: string;
    rf2FirstName: string | null;
    rf2LastName: string | null;
    rf2Address: string | null;
    rf2ZipCode: string | null;
    rf2City: string | null;
    rf2MobilePhoneNumber: string | null;
    rf2Email: string | null;
    rf2Job: string | null;
    rf2JobPhoneNumber: string | null;
    place: string;
    firstInscriptionYear: firstInscriptionYearType | null;
    selectedPromo: yearType;
    selectedPaymentMode: paymentModeType;
    signatureUrl: string;
    hasAlreadyAnEsajMaster: boolean;
};

type droitImageEntryType = {
    id: string;
    created_at: string;
    firstName: string;
    lastName: string;
    birthDate: string;
    optinStatus: optinStatusType;
    place: string;
    signatureUrl: string;
};

export { api };
export type {
    formationContinueDtoType,
    formationInitialeDtoType,
    formationInitialeEntryType,
    formationContinueEntryType,
    ficheInscriptionEntryType,
    droitImageEntryType,
    ficheRenseignementDtoType,
    ficheRenseignementEntryType,
};
